import useCrudForm from "../../../../hooks/useCrudForm";
import {
  CustomerModel,
  customerSchema,
} from "../../../customer/domain/model/CustomerModel";
import { useNavigate, useParams } from "react-router-dom";
import { LayoutModal } from "../../../general/modules/commons/layoutModal/layoutModal";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../hooks/useTypedSelector";
import { CustomerMutateFormTemplate } from "../../../customer/modules/commons/customerMutateFormTemplate/customerMutateFormTemplate";

export const RelationCustomerMutateModal = () => {
  const navigate = useNavigate();

  const { t } = useTranslation("common");

  const { id, customerId } = useParams();

  const model = useAppSelector((state) => state.crudMutate)
    .model as CustomerModel;

  const crud = useCrudForm({
    schema: customerSchema,
    prefix: "customers",
    createMutation: "upsertCustomer",
    updateMutation: "upsertCustomer",
    formTemplate: CustomerMutateFormTemplate,
    id: customerId ? parseInt(customerId) : undefined,
    defaultValues: {
      relation_id: id,
    },
    onAfterSubmit: () => {
      navigate(-1);
    },
  });

  const title = model.id
    ? t("relation.customer.mutate.edit", { name: model.name })
    : t("relation.customer.mutate.add");

  return (
    <LayoutModal
      title={title}
      show={true}
      onHide={() => navigate(-1)}
      actions={crud.formSubmit}
    >
      {crud.form}
    </LayoutModal>
  );
};
